export default __webpack_public_path__ + "static/dublin-30923213e155128f86555f6ba75a8a0a.svg";